export class Tenant {
    public static INVALID_TENANT_ID: string = "invalid-tenant-id";
    public static TenantMap = {
        "akula":  "akula-mo0yw",
        "internal": "lawtraxprod-0rb7l",
        "berardi": "berardi-nd0dp",
    }
}